import React from 'react'
import { useNavigate } from 'react-router-dom'

import { ConfirmModal, Toasts, useModalContext } from '@fourthwall/components'
import { YOU_FULFILL } from '@modules/Dashboard/Product/Product.consts'
import { useShippingProfilesQuery } from '@modules/Dashboard/pages/Settings/pages/Shipping/queries/useShippingProfilesQuery'
import { useOffersQuery } from '@queries/useOffersQuery'

import { useDeleteShippingProfileMutation } from '../../queries/useDeleteShippingProfileMutation'
import { ShippingGroupsYouShipView } from './ShippingGroupsYouShipView'
import { getShippingGroupLink } from './utils/getShippingGroupLink'
import { getShippingGroups } from './utils/getShippingGroups'

export const ShippingGroupsYouShipContainer = () => {
  const { open } = useModalContext()
  const navigate = useNavigate()
  const { deleteShippingProfileMutation } = useDeleteShippingProfileMutation()
  const { invalidateShippingProfilesQuery } = useShippingProfilesQuery()
  const { shippingProfilesQuery } = useShippingProfilesQuery()
  const shippingGroups = getShippingGroups(shippingProfilesQuery.data)
  const { offersQuery: selfFulfilledOffersQuery } = useOffersQuery([
    { fulfillmentService: YOU_FULFILL },
  ])
  const hasSelfFulfilledOffers = Boolean(selfFulfilledOffersQuery.data?.offers.length)

  const handleEdit = (id: string) => navigate(getShippingGroupLink(id))

  const handleDelete = (id: string, name: string) => {
    open(ConfirmModal, {
      title: `Are you sure that you want to remove ${name}?`,
      confirmLabel: 'Delete',
      confirmAppearance: 'destructive',
      onConfirm: async () => {
        await deleteShippingProfileMutation.mutateAsync([id], {
          onSuccess: () => {
            invalidateShippingProfilesQuery()
            Toasts.notify(`${name} has been removed.`, { type: 'success' })
          },
        })
      },
    })
  }

  return (
    <ShippingGroupsYouShipView
      shippingGroups={shippingGroups}
      disabled={!hasSelfFulfilledOffers && !shippingGroups.length}
      onEdit={handleEdit}
      onDelete={handleDelete}
    />
  )
}
